import { api } from '../index';

const REQUIREMENTS_PATH = '/api/internal/planning/requirements';
const WEEKLY_PLANS_PATH = '/api/internal/planning/weekly_plans';

export type WeeklyPlan = {
  id: number;
  requirementId: number;
  days: number[];
  durationMin: number | null;
  fixedStartTime: string | null;
  timeWindowStart: string | null;
  timeWindowEnd: string | null;
  caregiverId: number | null;
  caregiverFullName: string | null;
};

export interface WeeklyPlanForm {
  days: number[];
  durationMin?: number | null;
  fixedStartTime?: string | null;
  timeWindowStart?: string | null;
  timeWindowEnd?: string | null;
  caregiverId?: number | null;
}

export const weeklyPlansApi = {
  index(requirementId: number): Promise<WeeklyPlan[]> {
    return api({
      method: 'get',
      url: `${REQUIREMENTS_PATH}/${requirementId}/weekly_plans`,
    }).then(response => response.data.weeklyPlans);
  },
  create(requirementId: number, form: WeeklyPlanForm): Promise<WeeklyPlan> {
    return api({
      method: 'post',
      url: `${REQUIREMENTS_PATH}/${requirementId}/weekly_plans`,
      data: { weeklyPlan: form },
    }).then(response => response.data.weeklyPlan);
  },
  update(id: number, form: Partial<WeeklyPlanForm>): Promise<WeeklyPlan> {
    return api({
      method: 'put',
      url: `${WEEKLY_PLANS_PATH}/${id}`,
      data: { weeklyPlan: form },
    }).then(response => response.data.weeklyPlan);
  },
  destroy(id: number): Promise<void> {
    return api({
      method: 'delete',
      url: `${WEEKLY_PLANS_PATH}/${id}`,
    }).then(() => {});
  },
};
